<footer>
    <div class="d-flex justify-content-between align-items-center">
        <div class="logo d-none d-sm-block">
            <img src="assets/images/STC_logo_white.svg" class="stc-logo" [routerLink]="'/home'" />
        </div>
        <div class="d-flex contactdiv">
            <div class="contact-info">
                <small class="d-block mb-4 contact-number">
                    <a href="tel:+966501234567">{{ 'numberFooter' | translate }}</a></small>
                <small class="d-block">
                    <a href="mailto:{{ 'emailFooter' | translate }}">{{ 'emailFooter' | translate }}</a></small>
            </div>
            <div class="social-links">
                <ul class="copy-rights list-unstyled d-flex gap-3 mb-0">
                    <li>{{ 'allRightSaved' | translate: { year: currentYear } }}</li>
                </ul>
            </div>
        </div>
    </div>
</footer>
